
// import { TableRow, TableCell, TextField, Autocomplete, useTheme } from '@mui/material';
// import { tokens } from '../../theme/theme';

// const TableFilterRow = ({
//     columns,
//     filters,
//     handleFilterChange,
//     uniqueValues,
//     autoCompleteColumns = [],
// }) => {

//     const theme = useTheme();
//     const colors = tokens(theme.palette.mode);
//     return (
//         <TableRow sx={{ backgroundColor: colors.primary[500] }}>
//             {columns.map((col) => (
//                 <TableCell key={col} sx={{ padding: '4px' }}>
//                     {autoCompleteColumns.includes(col) ? (
//                         <Autocomplete
//                             freeSolo
//                             options={uniqueValues[col] || []}
//                             fullWidth
//                             // value={filters[col] || ''}
//                             value={filters[col] ?? ""}
//                             onInputChange={(event, newValue) =>
//                                 handleFilterChange({ target: { value: newValue } }, col)
//                             }
//                             renderInput={(params) => (
//                                 <TextField
//                                     {...params}
//                                     placeholder="Filter"
//                                     variant="standard"
//                                     fullWidth
//                                     InputProps={{
//                                         ...params.InputProps,
//                                         disableUnderline: true,
//                                     }}
//                                     sx={{
//                                         fontSize: '0.75rem',
//                                         borderRadius: 1,
//                                         px: 1,
//                                     }}
//                                 />
//                             )}
//                         />
//                     ) : (
//                         <TextField
//                             variant="standard"
//                             value={filters[col] || ''}
//                             onChange={(e) => handleFilterChange(e, col)}
//                             placeholder="Filter"
//                             fullWidth
//                             InputProps={{
//                                 disableUnderline: true,
//                             }}
//                             sx={{
//                                 fontSize: '0.75rem',
//                                 borderRadius: 1,
//                                 px: 1,
//                             }}
//                         />
//                     )}
//                 </TableCell>
//             ))}
//         </TableRow>
//     );
// };

// export default TableFilterRow;


import { TableRow, TableCell, TextField, Autocomplete, useTheme,alpha } from '@mui/material';
import { tokens } from '../../theme/theme';

const TableFilterRow = ({
    columns,
    filters,
    handleFilterChange,
    uniqueValues,
    autoCompleteColumns = [],
}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <TableRow
            sx={{
                backgroundColor: alpha(colors.primary[400], 0.15),
                borderBottom: `1px solid ${alpha(colors.primary[400], 0.3)}`,
                position: 'sticky',
                top: 0,
                zIndex: 20,
            }}
        >
            {columns.map((col) => (
                <TableCell
                    key={col}
                    sx={{
                        p: 0.5, // Ultra-compact 4px padding
                        borderBottom: 'none',
                        verticalAlign: 'middle',
                        minWidth: col === 'name' ? 160 : 'auto',
                    }}
                >
                    {autoCompleteColumns.includes(col) ? (
                        <Autocomplete
                            freeSolo
                            size="small"
                            options={uniqueValues[col] || []}
                            fullWidth
                            value={filters[col] ?? ''}
                            onInputChange={(event, newValue) =>
                                handleFilterChange({ target: { value: newValue } }, col)
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder={`Filter ${col}`}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    sx={{
                                        fontSize: '0.7rem', // 11px
                                        lineHeight: 1.2,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 1,
                                            px: 1.25,
                                            py: 0.25,
                                            bgcolor: alpha(colors.grey[900], 0.7),
                                            borderColor: alpha(colors.primary[300], 0.5),
                                            fontSize: '0.7rem',
                                            minHeight: '28px',
                                            '& fieldset': {
                                                border: 'none',
                                            },
                                            '&:hover': {
                                                bgcolor: alpha(colors.grey[800], 0.8),
                                                borderColor: colors.primary[400],
                                            },
                                            '&.Mui-focused': {
                                                bgcolor: colors.grey[900],
                                                borderColor: colors.primary[400],
                                                boxShadow: `0 0 0 2px ${alpha(colors.primary[400], 0.3)}`,
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            py: 0.25,
                                            px: 0.75,
                                        },
                                    }}
                                />
                            )}
                            ListboxProps={{
                                sx: {
                                    maxHeight: 120,
                                    '& .MuiListSubheader-root': {
                                        fontSize: '0.7rem',
                                    },
                                },
                            }}
                        />
                    ) : (
                        <TextField
                            variant="outlined"
                            size="small"
                            value={filters[col] || ''}
                            onChange={(e) => handleFilterChange(e, col)}
                            placeholder={`Filter ${col}`}
                            fullWidth
                            sx={{
                                fontSize: '0.7rem',
                                lineHeight: 1.2,
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: 1,
                                    px: 1.25,
                                    py: 0.25,
                                    bgcolor: alpha(colors.grey[900], 0.7),
                                    borderColor: alpha(colors.primary[300], 0.5),
                                    borderWidth: '1px',
                                    fontSize: '0.7rem',
                                    minHeight: '28px',
                                    '& fieldset': {
                                        border: 'none',
                                    },
                                    '&:hover': {
                                        bgcolor: alpha(colors.grey[800], 0.8),
                                        borderColor: colors.primary[400],
                                    },
                                    '&.Mui-focused': {
                                        bgcolor: colors.grey[900],
                                        borderColor: colors.primary[400],
                                        boxShadow: `0 0 0 2px ${alpha(colors.primary[400], 0.3)}`,
                                    },
                                },
                                '& .MuiInputBase-input': {
                                    py: 0.25,
                                    px: 0.75,
                                },
                            }}
                        />
                    )}
                </TableCell>
            ))}
        </TableRow>
    );
};

export default TableFilterRow;

